import { CustomerAddressDto, DeliveryCodeDto } from 'types/api/orders.type';

const formatAddressLabel = (address: CustomerAddressDto): string =>
  [
    address.addressLine1,
    address.city,
    address.subdivisionName,
    address.countryName,
    address.zipCode,
  ]
    .filter(Boolean)
    .join(', ');

const formatDeliveryCodeLabel = (dc: DeliveryCodeDto, lang: string): string => {
  const desc = lang.startsWith('en') ? dc.descriptionEn : dc.descriptionIt;
  return `${dc.code} - ${desc || dc.descriptionEn || dc.descriptionIt || ''}`;
};

export { formatAddressLabel, formatDeliveryCodeLabel };
